module.exports = __webpack_public_path__ + "assets/img/s1_tab1.293c6252.png";